import { render, staticRenderFns } from "./UserDetailsAdministrationGroupsWithRoles.vue?vue&type=template&id=01d94c26&scoped=true&"
import script from "./UserDetailsAdministrationGroupsWithRoles.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationGroupsWithRoles.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsAdministrationGroupsWithRoles.vue?vue&type=style&index=0&id=01d94c26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d94c26",
  null
  
)

export default component.exports